import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../Components/header";

const RiscattaCoupon = ({ giftCode, handleInputChange, couponError }) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(giftCode);
    console.log("CODICE REGALO:", giftCode);
  }, []);
  const handleChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
  };
  const handleRedeemClick = () => {
    // Logica per riscattare il codice regalo
    console.log("Codice regalo inserito:", giftCode);
    // Qui potresti aggiungere la logica per inviare il codice regalo al server per la verifica e il riscatto
  };

  return (
    <div className="w-full max-w-md mt-5">
      <label
        htmlFor="giftCode"
        className="block text-sm font-medium text-gray-700"
      >
        Inserisci il tuo codice regalo
      </label>
      <input
        type="text"
        id="giftCode"
        value={giftCode}
        onChange={handleInputChange}
        className={`mt-1 block w-46 ${
          couponError
            ? "border-red-500 focus:border-red-500"
            : "border-grey-300"
        } px-3 py-2 border  rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm transition-colors`}
        placeholder="Inserisci il codice"
      />
      {couponError && <p className="text-red-500 mt-2">{couponError}</p>}
    </div>
  );
};

export const CreaCoupon = () => {
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [emailDestinatario, setEmailDestinatario] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const couponData = {
      couponCode,
      discount,
      emailDestinatario,
    };

    // Logica per inviare i dati al server o passare al checkout
    navigate("/checkout", { state: { couponData } });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-col justify-center items-center p-8">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">
          Acquista un Coupon Regalo
        </h1>
        <p className="text-lg mb-6 text-gray-600">
          Sorprendi qualcuno di speciale con un coupon regalo! Inserisci i
          dettagli qui sotto e procedi con l'acquisto.
        </p>
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-md rounded-lg p-6 w-full max-w-md"
        >
          <label className="block text-gray-700 font-semibold mb-2">
            Valore del Coupon (€)
          </label>
          <input
            type="number"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            placeholder="Inserisci il valore del coupon"
            required
          />
          <label className="block text-gray-700 font-semibold mb-2">
            Email del Destinatario
          </label>
          <input
            type="email"
            value={emailDestinatario}
            onChange={(e) => setEmailDestinatario(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            placeholder="Inserisci l'email del destinatario"
            required
          />
          <button
            type="submit"
            className="w-full py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition"
          >
            Procedi al Pagamento
          </button>
          {message && (
            <p className="mt-4 text-green-600 font-semibold">{message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

const CodiceRegalo = ({
  giftCode,
  handleInputChange,
  couponError,
  activeTab,
  handleTabChange,
  emailDestinatario,
  setEmailDestinatario,
  sendOption,
  setSendOption,
}) => {
  //const [activeTab, setActiveTab] = useState("riscatta"); // Tab attiva: riscatta o invia
  const [inputValue, setInputValue] = useState(giftCode || "");
  //const [emailDestinatario, setEmailDestinatario] = useState("");

  // Precompila il valore del codice regalo, se presente
  useEffect(() => {
    setInputValue(giftCode);
  }, [giftCode]);

  // Gestisci il cambio del tab
  /*const handleTabChange = (tab) => {
    setActiveTab(tab);
  };*/

  // Logica per invio regalo
  const handleSendGift = () => {
    if (!emailDestinatario) {
      console.log("Inserisci un'email valida.");
      return;
    }
    console.log("Inviando regalo a:", emailDestinatario);
    console.log("Codice generato:", inputValue);
    // Logica per inviare il regalo
  };

  return (
    <div className="w-full max-w-lg mt-5">
      {/* Intestazione e schede */}
      <div className="relative flex justify-around border-b mb-5">
        <button
          className="w-1/2 py-2 text-center"
          onClick={() => {
            handleTabChange("riscatta");
            setTimeout(() => {
              setSendOption("direct");
            }, 800);
          }}
        >
          Riscatta il Codice
        </button>
        <button
          className="w-1/2 py-2 text-center"
          onClick={() => handleTabChange("invia")}
        >
          Invia come Regalo
        </button>

        {/* Indicatore attivo con transizione */}
        <div
          className={`absolute bottom-0 left-0 h-[2px] bg-blue-500 transition-all duration-300`}
          style={{
            width: "50%",
            transform:
              activeTab === "riscatta" ? "translateX(0%)" : "translateX(100%)",
          }}
        ></div>
      </div>

      {/* Sezione Riscatta Codice */}
      {activeTab === "riscatta" && (
        <div>
          <label
            htmlFor="giftCode"
            className="block text-sm font-medium text-gray-700"
          >
            Inserisci il tuo codice regalo
          </label>
          <input
            type="text"
            id="giftCode"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              handleInputChange(e);
            }}
            className={`mt-1 block w-full ${
              couponError
                ? "border-red-500 focus:border-red-500"
                : "border-gray-300"
            } px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm transition-colors`}
            placeholder="Inserisci il codice"
          />
          {couponError && <p className="text-red-500 mt-2">{couponError}</p>}
        </div>
      )}

      {/* Sezione Invia come Regalo */}
      {activeTab === "invia" && (
        <div>
          <label
            htmlFor="nomeDestinatario"
            className="block text-sm font-medium text-gray-700"
          >
            Dati destinatario
          </label>

          {sendOption !== "self" && (
            <input
              type="text"
              id="emailDestinatario"
              value={emailDestinatario}
              placeholder="Inserisci l'email del destinatario"
              onChange={(e) => setEmailDestinatario(e.target.value)}
              //className="transition duration-300 block border p-2 border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm"
              className="transition duration-300 mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm"
            />
          )}
        </div>
      )}
    </div>
  );
};

/*<button
        style={{
          opacity: activeTab === "riscatta" ? "0%" : "100%",
        }}
        onClick={handleSendGift}
        className="duration-300 transition-all mt-5 w-full bg-green-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      >
        Invia come Regalo
      </button>*/
export default CodiceRegalo;
